import { Button } from '@/components/UI/Button'
import { Dialog } from '@/components/UI/Dialog'
import { IconLock } from '@tabler/icons-react'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  onClose: () => void
  /** storybookで確認する際に、スクロール可にするためのフラグ。raundで利用する場合にはtrue */
  scrollLock?: boolean
  /**
   * 位置情報を取得できていないか。
   * サーバーは座標が無い場合も一律 out_of_range を返すため、これが true のときは
   * 「範囲外」ではなく「位置情報が取得できていない」ことを案内する（#3445）。
   */
  locationUnavailable?: boolean
}

/**
 * 音声ガイドが利用できない状態を表示するダイアログ。
 * 有効範囲外・位置情報未取得で文言を出し分ける。
 */
export const DialogAudioGuideLocked = memo(({ onClose, scrollLock = false, locationUnavailable = false }: Props) => {
  const { t } = useTranslation()

  const message = locationUnavailable
    ? t(
        'spot_detail.location_unavailable_message',
        '位置情報を取得できないため\nご利用いただけません。\n端末の位置情報設定をご確認ください。',
      )
    : t('spot_detail.audio_guide.out_of_range_message', '音声ガイドは\n有効範囲内で\nご利用いただけます。')

  return (
    <Dialog selectorState={true} compact showCloseButton={false} lockScroll={scrollLock} closeAction={onClose}>
      <div className="flex flex-col items-center gap-[16px]">
        <div className="flex items-center justify-center w-[64px] h-[64px] rounded-full bg-[#f5f5f5]">
          <IconLock size={32} className="text-[#757575]" />
        </div>

        <p className="text-center text-[14px] font-bold text-black leading-[22px]">{message}</p>

        <Button label={t('common.close', '閉じる')} variant="primary" size="md" onClick={onClose} fullWidth />
      </div>
    </Dialog>
  )
})

DialogAudioGuideLocked.displayName = 'DialogAudioGuideLocked'
